import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { keyBy } from "lodash";

import Graph_QL, { DynamicDataObk } from "../..";
import { AnimalInfo } from "../GQLCalls/getAnimalCall";

export type AnimalItem = DynamicDataObk<AnimalInfo[]>

const animalsDataAdapter = createEntityAdapter({
  selectId: (item: AnimalItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<AnimalItem, string>, {con, data}: AnimalItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const dataDictionary = keyBy(state.entities[identifier].data, "animalId")
    data.forEach((entry) => dataDictionary[entry.animal_id] = entry)
    const newPayload = {con, data: Object.values(dataDictionary)}
    animalsDataAdapter.upsertOne(state, newPayload);
  } else { animalsDataAdapter.addOne(state, {con, data})}
}

const removeDeletedFromState = (state: EntityState<AnimalItem, string>, {con, data}: AnimalItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const idsToRemove = data.map((animal) => (animal.animal_id));
    const newPayload = {con, data: state.entities[identifier].data.filter((animal) => idsToRemove.includes(animal.animal_id))}
    animalsDataAdapter.upsertOne(state, newPayload);
  }
}

const animalSlice = createSlice({
  name: "animals",
    initialState: animalsDataAdapter.getInitialState<AnimalItem[]>([]),
      reducers: {
        maintained: (state, {payload}:PayloadAction<AnimalItem>) => {
          mergePayloadAndState(state, payload);
        },
        deleted: (state, {payload}) => {
          removeDeletedFromState(state, payload)
        }
    }
})

export const AnimalActions = animalSlice.actions;
export default animalSlice.reducer;